import React from 'react';
import { Box, Typography, Button, Grid, LinearProgress } from '@mui/material';
import { mockProjects } from '../data/mockData';

const ProjectsPage: React.FC = () => {
  return (
    <Box sx={{ p: 4, height: '100%', overflow: 'auto', bgcolor: 'var(--hp-bg)' }}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 4 }}>
        <Box>
          <Typography variant="h5" sx={{ fontWeight: 'bold', color: 'var(--hp-text)' }}>All Projects</Typography>
          <Typography color="var(--hp-text-secondary)" sx={{ mt: 0.5 }}>Overview of all tracked initiatives</Typography>
        </Box>
        <Button variant="contained" sx={{ bgcolor: 'var(--hp-primary)', textTransform: 'none', borderRadius: '8px', boxShadow: 'none' }}>
          Create Project
        </Button>
      </Box>

      <Grid container spacing={3}>
        {mockProjects.map(project => (
          <Grid size={{ xs: 12, sm: 6, md: 4 }} key={project.id}>
            <Box className="neumorphic-card" sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
               <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                 <Box sx={{ width: 48, height: 48, borderRadius: '12px', bgcolor: `${project.color}20`, color: project.color, display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 'bold', fontSize: '1.2rem' }}>
                   {project.code}
                 </Box>
                 <Box>
                   <Typography sx={{ fontWeight: 'bold', fontSize: '1.1rem' }}>{project.name}</Typography>
                   <Typography variant="caption" color="var(--hp-text-secondary)">{project.epicCount} Epics • {project.storyCount} Stories</Typography>
                 </Box>
               </Box>
               
               <Box sx={{ mt: 1 }}>
                 <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 0.5 }}>
                   <Typography variant="caption" sx={{ fontWeight: 'bold' }}>Sprint Progress</Typography>
                   <Typography variant="caption" color="var(--hp-text-secondary)">{project.onTrackPct}%</Typography>
                 </Box>
                 <LinearProgress variant="determinate" value={project.onTrackPct} sx={{ height: 6, borderRadius: 3, bgcolor: 'var(--hp-border)', '& .MuiLinearProgress-bar': { bgcolor: project.color, borderRadius: 3 } }} />
               </Box>

               <Box sx={{ display: 'flex', gap: 2, mt: 1 }}>
                 {/* Scrum Health Score hidden for now */}
                 <Box>
                    <Typography variant="h6" sx={{ fontWeight: 'bold', color: 'var(--hp-danger)' }}>{project.blockedPct}%</Typography>
                    <Typography variant="caption" color="var(--hp-text-secondary)">Blocked</Typography>
                 </Box>
               </Box>
            </Box>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default ProjectsPage;